import React from "react";
import { MdDateRange } from "react-icons/md";
import { format } from "date-fns";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DateFilter = ({
  date,
  setDate,
  dateFilterModalOpen,
  setDateFilterModalOpen,
  setFilterByObj,
  filterByObj,
}) => {
  const handleDateFilterClick = () => {
    setDateFilterModalOpen(true);
  };

  const handleCloseDateFilterModal = () => {
    setDateFilterModalOpen(false);
  };

  const handleDateChange = (ranges) => {
    const selected = ranges.selection;

    const adjustedStartDate = new Date(selected.startDate);
    adjustedStartDate.setHours(0, 0, 0, 0); // Start of day

    const adjustedEndDate = new Date(selected.endDate);
    adjustedEndDate.setHours(23, 59, 59, 999); // End of day

    setFilterByObj({
      ...filterByObj,
      from: format(adjustedStartDate, "yyyy-MM-dd HH:mm:ss"),
      to: format(adjustedEndDate, "yyyy-MM-dd HH:mm:ss"),
    });

    setDate(selected);

    if (
      selected.startDate &&
      selected.endDate &&
      selected.startDate.getTime() !== selected.endDate.getTime()
    ) {
      setDateFilterModalOpen(false);
    }
  };

  return (
    <div className="justify-content-start mt-2" style={{ marginLeft: 0 }}>
      <button
        className="calender btn btn-info"
        onClick={handleDateFilterClick}
        style={{
          fontSize: "11px",
          backgroundColor: "rgb(62, 72, 112)",
          border: "none",
        }}
      >
        <MdDateRange size={16} style={{ display: "inline" }} />{" "}
        {date
          ? `${format(date.startDate, "MMM dd yyyy")} -- ${format(
              date.endDate,
              "MMM dd yyyy"
            )}`
          : "Select Calender Date"}
      </button>

      <div
        className={`modal ${dateFilterModalOpen ? "show" : ""} bg-black-7`}
        style={{
          display: dateFilterModalOpen ? "block" : "none",
        }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content" style={{ borderRadius: "8px" }}>
            <div className="modal-header">
              <h5 className="modal-title">Select Date Range</h5>
              <button
                type="button"
                className="close"
                onClick={handleCloseDateFilterModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ width: "100%" }}>
              <DateRangePicker
                ranges={
                  date
                    ? [date]
                    : [
                        {
                          startDate: new Date(),
                          endDate: new Date(),
                          key: "selection",
                        },
                      ]
                }
                onChange={handleDateChange}
                moveRangeOnFirstSelection={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateFilter;
